export { TrendingUp as default } from './TrendingUp';
